// extracted by mini-css-extract-plugin
export default {"savedSearchesButton":"savedSearchesButton__MmYxN","button":"button__ZjM1Z","searches":"searches__ZDg2M"};